import React, { useEffect, useState } from 'react';
import { createClient } from '../../../lib/supabase/client';

export default function OverdueInvoicesAlert() {
  const [overdueCount, setOverdueCount] = useState(0);

  useEffect(() => {
    const fetchOverdue = async () => {
      const supabase = createClient();
      const today = new Date().toISOString().split('T')[0];
      
      const { data } = await supabase
        .from('invoices')
        .select('id')
        .in('status', ['sent', 'overdue'])
        .lt('due_date', today);

      setOverdueCount(data?.length || 0);
    };

    fetchOverdue();
  }, []);

  if (overdueCount === 0) {
    return null;
  }

  return (
    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <span className="text-yellow-600 text-xl">⚠️</span>
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-yellow-800">
            {overdueCount} facture{overdueCount > 1 ? 's' : ''} en retard
          </h3>
          <p className="text-sm text-yellow-700 mt-1">
            Vous avez {overdueCount} facture{overdueCount > 1 ? 's' : ''} en retard de paiement.
          </p>
        </div>
      </div>
    </div>
  );
}

